var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrequency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M1 2C1.6 2.5 2.2 3 3.5 3C6 3 6 1 8.5 1C9.8 1 10.4 1.5 11 2C11.6 2.5 12.2 3 13.5 3C16 3 16 1 18.5 1C19.8 1 20.4 1.5 21 2M1 14C1.6 14.5 2.2 15 3.5 15C6 15 6 13 8.5 13C9.8 13 10.4 13.5 11 14C11.6 14.5 12.2 15 13.5 15C16 15 16 13 18.5 13C19.8 13 20.4 13.5 21 14M1 8C1.6 8.5 2.2 9 3.5 9C6 9 6 7 8.5 7C9.8 7 10.4 7.5 11 8C11.6 8.5 12.2 9 13.5 9C16 9 16 7 18.5 7C19.8 7 20.4 7.5 21 8",
    stroke: "#F7F9F9",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrequency);
export default __webpack_public_path__ + "static/media/frequency.2f7f5995269e581d72f31ef5f6d1b716.svg";
export { ForwardRef as ReactComponent };